import { render, staticRenderFns } from "./SettingsAdmins.vue?vue&type=template&id=247c9997&scoped=true&"
import script from "./SettingsAdmins.vue?vue&type=script&lang=js&"
export * from "./SettingsAdmins.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAdmins.vue?vue&type=style&index=0&id=247c9997&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247c9997",
  null
  
)

export default component.exports